const VIDEO_SELECTOR = '[data-product-story-video]';
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector('video');
      if (!video || entry.target.dataset.autoplay !== 'true' || prefersReducedMotion.matches) return;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  },
  { rootMargin: '160px 0px', threshold: 0.01 }
);

const initializeVideos = (root = document) => {
  root.querySelectorAll(VIDEO_SELECTOR).forEach((container) => {
    if (container.dataset.videoReady) return;
    container.dataset.videoReady = 'true';
    const video = container.querySelector('video');
    if (video) video.preload = 'none';
    observer.observe(container);
  });
};

initializeVideos();
document.addEventListener('shopify:section:load', (event) => initializeVideos(event.target));
